import { Component, OnInit, OnDestroy } from '@angular/core';
import { environment } from 'environments/environment';
import { MatDialog } from '@angular/material';
import { DraftService } from '../../services/draft.service';
import { UserService } from 'shared/services/User/user.service';
import { DraftComponent } from '../draft/draft.component';
import { SearchGamePipe } from 'shared/pipes/searchGame/searchGame.pipe';

@Component({
  selector: 'app-draft-game',
  templateUrl: './draft-game.component.html',
  styleUrls: ['./draft-game.component.css']
})
export class DraftGameComponent implements OnInit, OnDestroy {

  ALL_GAMES: any[] = [];
  _GAMES: any[];
  _GAMES_COPY: any[];
  QUEUED_GAMES: any[];
  currentUID;
  imgURLHandle = environment.URL_TEAM_IMAGES;
  thumbImgHandle = environment.URL_THUMB_IMAGES;
  _TEAM;
  queueGameSubscription;
  pickTicketSubscription;

  constructor(
    public dialog: MatDialog,
    private draftService: DraftService,
    private userService: UserService,
    private draftComponent: DraftComponent,
    private searchGamePipe: SearchGamePipe) {
    this.currentUID = this.userService.user.uid;
    this.queueGameSubscription = draftService.queueGameList$.subscribe(games => {
      this._TEAM = draftService.CURRENT_GROUP.season_ticket.team;
      this._GAMES = games; // setting games to all games
      this._GAMES_COPY = games; // setting games to all games
    });

    this.pickTicketSubscription = draftService.pickedTicketSubscription$.subscribe(pickedTicketData => {
      const index: any = this._GAMES.findIndex((oneGame) => {
        return oneGame.game_id === pickedTicketData.game_id;
      });
      this._GAMES[index]['picked'] = true;
      this._GAMES[index]['chooser'] = pickedTicketData.name;
      this._GAMES[index]['chooser_img'] = pickedTicketData.thumb_img;
      setTimeout(() => {
        this._GAMES[index]['fadeOut'] = true;
      }, 1500);
    });
    this.draftComponent.searchQueuedGames.subscribe(data => {
      this._GAMES = this.searchGamePipe.transform(this._GAMES_COPY, data);
    });
  }

  filterGames(games) {
    this._GAMES = games.filter(element => {
      return element.isQueued === true;
    });
    this._GAMES.sort((a, b) => parseFloat(a.q_tstamp) - parseFloat(b.q_tstamp));
  }

  queueGame(game, index) {
    if (!game.isQueued || game.isQueued === undefined) {
      game.q_tstamp = Date.now();
      game.q_uid = this.userService.user.uid;
      game.isQueued = true;
    } else {
      game.isQueued = !game.isQueued;
      game.q_tstamp = 0;
      game.q_uid = 0;
    }
    this.draftService.updateUserQueueArray(this._GAMES);
    this.draftService.queueGame(game);
  }

  ngOnInit() { }

  ngOnDestroy() {
    this.queueGameSubscription.unsubscribe();
    this.pickTicketSubscription.unsubscribe();
  }

}



// WEBPACK FOOTER //
// ./src/app/modules/draft/components/draft-game/draft-game.component.ts